import differenceInHours from 'date-fns/differenceInHours'

const isLessThanXHours = (appointmentStartDate: string, hours = 24): boolean => {
  return differenceInHours(new Date(appointmentStartDate), new Date()) < hours
}

export default isLessThanXHours
